import { QuestionCircleOutlined } from '@ant-design/icons'
import { createSelector } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import { Typography, Popover, Card, Radio } from 'antd'
import { USERMODES } from 'Types'
import { setUserMode } from 'Actions/user'

{ Paragraph } = Typography

helpText = (<div style={{ width: 500, lineHeight: '1.6rem' }}>
  <Paragraph>
    Sets the user mode. By default it's set to 'Simple'.
    There are three user modes:<br/>
      - Simple: Only basic features<br/>
      - Advanced: Some more detailed features<br/>
      - Expert: All features<br/>
  </Paragraph>
</div>)

info = (
  <Popover
    content={helpText}
    title='Open view by default'
    trigger="click"
    placement="left"
  >
    <a><QuestionCircleOutlined /></a>
  </Popover>
)

modeSelector = createSelector((state) ->
  state.user.userMode
, (val) -> val)

UseModePanel = ->
  mode = useSelector(modeSelector)
  dispatch = useDispatch()

  <Card
    title="User mode"
    extra={info}
    size="small"
    id="open-default-view-settings"
  >
    <Radio.Group
      onChange={(e) ->
        dispatch(setUserMode(e.target.value))
      }
      defaultValue={mode}
    >
      {
        _.map(USERMODES, (userMode, key) ->
          <Radio.Button key={key} value={userMode}>{ _.capitalize(key) }</Radio.Button>
        )
      }
    </Radio.Group>
  </Card>

export default UseModePanel
